import { Button } from 'antd'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import Dialog from '../../../common/Dialog'
import { clinicName } from '../../../../utils/clinicsUtils'
import { clinicTypes } from '../../../../consts'

import './StartClinicIntakeDialog.css'

const StartClinicIntakeDialog = () => {
  const dispatch = useDispatch()
  const promptClinic = useSelector(state => state.getCare.promptClinic)

  const [isInitClinicSkipped, setIsInitClinicSkipped] = useState(false)
  // promptClinic is object of the message and the skip message (after pressing 'no')
  const initClinicMessage = $t('clinicsInit.title', {
    clinic: clinicName(promptClinic),
  })
  const skipInitClinicMessage = $t('clinicsInit.skip', {
    clinic: clinicName(promptClinic),
  })

  const startIntake = () => {
    switch (promptClinic) {
      case clinicTypes.HTN:
        dispatch(Actions.createAction(Actions.HYPERTENSION_CLICKED))
        break
      case clinicTypes.DIABETES:
        dispatch(Actions.createAction(Actions.DIABETES_CLICKED))
        break
      case clinicTypes.MENTAL:
        dispatch(Actions.createAction(Actions.MENTALHEALTH_CLICKED))
        break
      default: {
        break
      }
    }

    dispatch(Actions.createAction(Actions.START_CLINIC_ABORTED))
  }

  return (
    <Dialog
      className="init-clinic-dialog"
      title={isInitClinicSkipped ? skipInitClinicMessage : initClinicMessage}
      isVisible={!!promptClinic}
      closable={isInitClinicSkipped}
      onCancel={() =>
        dispatch(Actions.createAction(Actions.START_CLINIC_ABORTED))
      }
      footerActions={
        isInitClinicSkipped
          ? [
              <Button
                key="init-1"
                className="dialog-action trackable"
                data-name="ok"
                type="primary"
                onClick={() => {
                  isInitClinicSkipped
                    ? dispatch(
                        Actions.createAction(Actions.START_CLINIC_ABORTED)
                      )
                    : startIntake()
                }}
              >
                {isInitClinicSkipped ? $t('common.ok') : $t('common.okStart')}
              </Button>,
            ]
          : [
              <Button
                key="init-2"
                data-name="no"
                className="dialog-action"
                onClick={() => setIsInitClinicSkipped(true)}
              >
                {$t('common.no')}
              </Button>,
              <Button
                key="init-3"
                className="dialog-action trackable"
                type="primary"
                data-name="ok"
                onClick={() => {
                  isInitClinicSkipped
                    ? dispatch(
                        Actions.createAction(Actions.START_CLINIC_ABORTED)
                      )
                    : startIntake()
                }}
              >
                {isInitClinicSkipped ? $t('common.ok') : $t('common.okStart')}
              </Button>,
            ]
      }
    />
  )
}

export default StartClinicIntakeDialog
